//import "antd/dist/antd.css";
import { Table as AntdTable, Pagination } from 'antd';



// Custom pagination component
const TablePagination = ({ total, onChange, current,pageSize }) => {
  return (
    <Pagination
      className='r_pagination'
      onChange={onChange}
      total={total}
      current={current}
      pageSize={pageSize}
      showSizeChanger={false}
      hideOnSinglePage={true}
      responsive={true}
      showQuickJumper={false}
    />
  );
};


export default TablePagination

